import { Box, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ModalWrapper } from 'src/components'

import { useStyles } from '../styles'

interface IProps {
  open: boolean
  handleClose: () => void
  declineReasonInfo: string
}

export const DeclineInfoModal = ({ open, handleClose, declineReasonInfo }: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()
  const theme = useTheme()

  return (
    <ModalWrapper
      open={open}
      onClose={() => {
        handleClose()
      }}
      className={classes.declineInfoModal}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',

          gap: '12px',
        }}
      >
        <Typography
          sx={{
            color: theme.palette.custom.warning2,
            fontSize: '18px',
            fontWeight: 600,
            width: '100%',
            textAlign: 'center',
            mb: '10px',
          }}
        >
          Decline Details
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: theme.palette.custom.darkBlue2,
          }}
        >
          Your submission has been declined for the following reason:
        </Typography>

        <Box
          sx={{
            backgroundColor: theme.palette.grey[100],
            padding: theme.spacing(2),
            borderRadius: '8px',
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.custom.darkBlue2,
            }}
          >
            {declineReasonInfo}
          </Typography>
        </Box>
      </Box>
    </ModalWrapper>
  )
}
